<template lang="html">
  <div
    v-if="type !== null"
    :class="['setting-form-item', `for-${type}`, {'is-required': isRequired}]"
  >
    <label
      v-if="isSpecific && hasi18nKey && type !== hidden"
      :for="name"
    >{{ $t(`templates.${i18nkey}`) }}</label>
    <label
      v-else-if="!isSpecific && hasi18nKey"
      :for="name"
    >{{ $t(`ui.general-model.${i18nkey}`) }}</label>
    <slot />
  </div>
</template>

<script>
import { HIDDEN } from '../config'

export default {
  name: 'SettingFormItem',

  props: {
    type: { type: String, default: null },
    name: { type: String, required: true },
    i18nkey: { type: String, default: '' },
    isRequired: { type: Boolean, default: false },
    isSpecific: { type: Boolean, default: false }
  },

  computed: {
    hasi18nKey () {
      return !(this.i18nkey === '' || !this.i18nkey)
    },

    hidden () {
      return HIDDEN
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/styles/variables";
.setting-form-item{
  display: flex;
  align-items: center;

  &.for-textarea{
    flex-direction: column;
    align-items: flex-start;
  }

  &.for-select{
    margin: 7px 0;
    justify-content: space-between;
  }
  &.is-required{
    border-radius: 2px;

    label{
      color: #A2b4b4;
    }
    input{
      color: #364040;
      color: white;
    }
  }

  label{
    margin-right: 12px;
    font-size: $f18;
    font-weight: 400;
    color: #A2b4b4;
    cursor: pointer;
  }

  label[for*="text_"], label[for*="url_"], label[for*="number_"], label[for*="geocode_"]{
    display: block;
    white-space:nowrap;
    bottom: 3px;
    flex-grow: 0;
  }
}
</style>
